import styled from 'styled-components'

export const StyleWrap = styled.div`
  .terms-container {
    height: 50rem;
  }
`
